/**
 * percent of image in center
 */
export const licensePlateRectangle = { x: 0.6, y: 0.2 };
export const qrCodeRectangle = { x: 0.5, y: 0.5 };
